import {
  mdiAlphaMCircleOutline,
  mdiChartLine,
  mdiChartTimeline,
  mdiCheckNetwork,
  mdiDatabaseSearch,
  mdiDna,
  mdiShape,
  mdiHistory,
  mdiSigmaLower,
  mdiSpeedometer,
  mdiTable,
  mdiAccountGroupOutline,
  mdiTextBoxMultipleOutline,
  mdiAccountOutline,
  mdiTestTube,
  mdiTransitConnectionVariant,
  mdiHeartOffOutline,
  mdiPill,
  mdiVirusOutline,
  mdiEyeCircleOutline,
  mdiHospitalBuilding,
  mdiNeedle,
  mdiHeartFlash,
  mdiMapMarkerOutline,
  mdiCompareHorizontal,
  mdiNoteTextOutline,
  mdiCurrencyUsd,
} from "@mdi/js";

export const reports = [
  {
    folder: "Data Source Release",
    icon: mdiSigmaLower,
    name: "Data Quality",
    routeName: "dataQuality",
    reports: [],
  },
  {
    folder: "Data Source Release",
    icon: mdiAccountOutline,
    name: "Person",
    routeName: "person",
    reports: [],
  },
  {
    folder: "Data Source Release",
    icon: mdiTable,
    name: "Domains",
    routeName: "domainTable",
    childName: "concept",
    domain: true,
    reports: [
      {
        folder: "Data Source Release",
        icon: mdiVirusOutline,
        name: "Conditions",
        routeName: "domainTable",
        domain: "condition_occurrence",
      },
      {
        folder: "Data Source Release",
        icon: mdiVirusOutline,
        name: "Condition Eras",
        routeName: "domainTable",
        domain: "condition_era",
      },
      {
        folder: "Data Source Release",
        icon: mdiPill,
        name: "Drugs",
        routeName: "domainTable",
        domain: "drug_exposure",
      },
      {
        folder: "Data Source Release",
        icon: mdiPill,
        name: "Drug Eras",
        routeName: "domainTable",
        domain: "drug_era",
      },
      {
        folder: "Data Source Release",
        icon: mdiHospitalBuilding,
        name: "Visit Occurrence",
        routeName: "domainTable",
        domain: "visit_occurrence",
      },
      {
        folder: "Data Source Release",
        icon: mdiHospitalBuilding,
        name: "Visit Detail",
        routeName: "domainTable",
        domain: "visit_detail",
      },
      {
        folder: "Data Source Release",
        icon: mdiTestTube,
        name: "Measurements",
        routeName: "domainTable",
        domain: "measurement",
      },
      {
        folder: "Data Source Release",
        icon: mdiEyeCircleOutline,
        name: "Observations",
        routeName: "domainTable",
        domain: "observation",
      },
      {
        folder: "Data Source Release",
        icon: mdiNeedle,
        name: "Procedures",
        routeName: "domainTable",
        domain: "procedure_occurrence",
      },
      {
        folder: "Data Source Release",
        icon: mdiHeartFlash,
        name: "Device Exposures",
        routeName: "domainTable",
        domain: "device_exposure",
      },
    ],
  },
  {
    folder: "Data Source Release",
    icon: mdiAccountGroupOutline,
    name: "Cohorts",
    routeName: "cohorts",
    reports: [],
  },
  {
    folder: "Data Source Release",
    icon: mdiChartLine,
    name: "Data Density",
    routeName: "dataDensity",
    reports: [],
  },
  {
    folder: "Data Source Release",
    icon: mdiEyeCircleOutline,
    name: "Observation Period",
    routeName: "observationPeriod",
    reports: [],
  },
  {
    folder: "Data Source Release",
    icon: mdiCurrencyUsd,
    name: "Cost Table",
    routeName: "costTable",
  },
  {
    folder: "Data Source Release",
    icon: mdiMapMarkerOutline,
    name: "Location",
    routeName: "location",
    reports: [],
  },
  {
    folder: "Data Network",
    icon: mdiCompareHorizontal,
    name: "Network Comparison Tool",
    routeName: "networkComparisonTool",
  },
  {
    folder: "Data Network",
    icon: mdiNoteTextOutline,
    name: "Network Annotations Report",
    routeName: "networkAnnotationsReport",
  },
  {
    folder: "Data Network",
    icon: mdiDatabaseSearch,
    name: "Data Source Feasibility",
    routeName: "feasibility",
  },
  {
    folder: "Data Network",
    icon: mdiDatabaseSearch,
    name: "Web API",
    routeName: "webApi",
    webApiRequired: true,
  },
  {
    folder: "Data Network",
    icon: mdiSpeedometer,
    name: "Network Performance",
    routeName: "networkPerformance",
  },
  {
    folder: "Data Source",
    icon: mdiHistory,
    name: "Data Quality History",
    routeName: "dataQualityHistory",
  },
  {
    folder: "Data Source",
    icon: mdiTable,
    name: "Data Source Overview",
    routeName: "dataSourceOverview",
  },
  {
    folder: "Data Source",
    icon: mdiChartTimeline,
    name: "Domain Continuity",
    routeName: "domainContinuity",
    reports: [],
  },
  {
    folder: "Data Source Release",
    icon: mdiHeartOffOutline,
    name: "Death",
    routeName: "death",
    reports: [],
  },
  {
    folder: "Data Source Release",
    icon: mdiTransitConnectionVariant,
    name: "Unmapped Source Codes",
    routeName: "unmappedSourceCodes",
    reports: [],
  },
  {
    folder: "Data Source Release",
    icon: mdiAlphaMCircleOutline,
    name: "Metadata",
    routeName: "metadata",
    reports: [],
  },
  {
    folder: "Data Source Release",
    icon: mdiTextBoxMultipleOutline,
    name: "Temporal Characterization",
    routeName: "temporalCharacterization",
    reports: [],
  },
  {
    folder: "Data Source Release",
    icon: mdiSpeedometer,
    name: "Performance",
    routeName: "performance",
    reports: [],
  },
  {
    folder: "Data Network",
    icon: mdiTable,
    name: "Overview",
    routeName: "overview",
  },
  {
    folder: "Data Network",
    icon: mdiSigmaLower,
    name: "Quality Assessment",
    routeName: "networkDataQuality",
  },
  {
    folder: "Data Network",
    icon: mdiChartLine,
    name: "Population Overview",
    routeName: "population",
  },
  {
    folder: "Data Network",
    icon: mdiShape,
    name: "Network Diversity Report",
    routeName: "networkDiversityReport",
  },
  {
    folder: "Data Network",
    icon: mdiDna,
    name: "Data Strand Report",
    routeName: "dataStrandReport",
  },
  {
    folder: "Data Network",
    icon: mdiTable,
    name: "Unmapped Source Codes",
    routeName: "networkUnmappedSourceCodes",
  },
];
